export class HttpError extends Error {
  constructor (message, status, statusText, body = null) {
    super(message)
    this.name = 'HttpError'
    this.status = status
    this.statusText = statusText
    this.body = body
  }
}

export const sendHttpRequest = async (url, method, headers, body, signal) => {
  let response
  try {
    response = await fetch(url, { method, headers, body, signal })

    if (!response.ok) {
      const errorBodyText = await response.text()

      throw new HttpError(
        `HTTP Error: ${response.status} ${response.statusText}`,
        response.status,
        response.statusText,
        errorBodyText
      )
    }

    return response
  } catch (error) {
    if (error instanceof HttpError) {
      throw error
    }
    throw new Error(`Network request failed: ${error.message}`)
  }
}
